import {loginPath} from "../lib/clinicSignIn";
import React, {useState, useEffect, useRef, useReducer} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {verifyUser} from "../authRequests";
import {patientReducer, init} from "../additional_files/reducer";
import Layout from "../components/Layout";
import {Box} from "@chakra-ui/react";
import PatientChat from "../components/PatientChat";

export default function Chat() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const loadedRef = useRef(null);
  const location = useLocation();
  const state = location.state;
  const [dashState, dispatch] = useReducer(patientReducer, state, init);

  useEffect(() => {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  useEffect(() => {
    if (!state || !state.patient) {
      navigate(loginPath());
    }
  }, [state, navigate]);

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      {state && state.patient && (
        <Box flex={1} w="100%" overflow="hidden">
          <PatientChat 
            patient={state.patient}
            dashState={dashState}
            dispatch={dispatch}
          />
        </Box>
      )}
    </Layout>
  );
}